import { DoDateServices } from "./Services.Interface";

const { REACT_APP_LOCAL } = process.env;
let url_base = `${REACT_APP_LOCAL}/EnterpriseServices/Sel/Solicitud`;
let method = "POST";

export interface ConsultarQuejasRequest {
  userID: string;
  TipoConsulta: string;
  accountNumber:string;
}

export type Queja = {
  Fecha: string;
  Queja: string;
  Numero_ss: string;
}

export interface ConsultarQuejasResponse {
  respuesta: string | null;
  respuestadesc: string | null;
  Quejas: Queja[] | null;
}

export const getDataService_ConsultarQuejas = (
  consultarQuejasReq: ConsultarQuejasRequest
) => {

  const doDataServices: DoDateServices = {
    serviceName: "generarQueja",
    url: url_base,
    method: method,
    request: JSON.stringify(consultarQuejasReq)
  };

  return doDataServices;
};